import Component from '@component';

import device from '../utils/html/Device';
import getData from '../utils/html/getData';
import Easing from './Easing';
import getAbsoluteOffset from '../utils/html/getAbsoluteOffset';

export default class Anchor extends Component {
	onInit(el) {
		this.el = el;
		this.target = document.querySelector(getData(this.el, 'target'));
		this.easing = null;
	}

	onReady() {
		if (this.target) {
			this.onResize();

			this.el.addEventListener(device.pointerdown, () => {
				this.scrollTo();
			});

			this.el.addEventListener('keydown', (e) => {
				if (
					e.key === 'Enter' ||
					e.keyCode === 13 ||
					e.key === 'Space' ||
					e.keyCode === 32
				) {
					this.scrollTo();
					this.target.setAttribute('tabindex', 0);
					this.target.focus();
				}
			});
		}
	}

	scrollTo() {
		this.easing = new Easing({
			type: 'easeInOutQuad',
			duration: 800,
			start: device.scroll.top,
			end: this.offset.top,
			callback: () => {
				this.easing.onDestroy();
				this.easing = null;
			},
		});
		this.easing.isActive = true;
	}

	onUpdate() {
		if (this.easing === null) {
			return;
		}

		window.scrollTo(0, this.easing.value);
	}

	onResize() {
		if (this.target) {
			this.offset = getAbsoluteOffset(this.target);
		}
	}
}
